import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayService } from '@vallift/ngl';
import {
  CreateFormOverlayComponent,
  type CreateFormOverlayResult,
} from '../components/create-form-overlay/create-form-overlay';
import { CreateFormAiHandoffService } from './create-form-ai-handoff.service';

@Injectable({ providedIn: 'root' })
export class CreateFormFlowService {
  private readonly overlayService = inject(OverlayService);
  private readonly router = inject(Router);
  private readonly aiHandoff = inject(CreateFormAiHandoffService);

  openCreateFormModal(): void {
    const dialogRef = this.overlayService.openModal(CreateFormOverlayComponent, {fitContent: true});

    dialogRef.closed.subscribe((result: CreateFormOverlayResult | null | undefined) => {
      if (!result) {
        return;
      }

      if (result.entry === 'ai' && result.initialPrompt) {
        this.aiHandoff.set(result.initialPrompt);
      } else {
        this.aiHandoff.clear();
      }

      void this.router.navigate(['/forms/builder', result.slug], {
        queryParams: { mode: result.entry === 'ai' ? 'ai' : 'manual' },
      });
    });
  }
}
